export default "__VITE_ASSET__884bbc4b__"